import axios from "axios";

const baseAxios = axios.create({
  // Use environment variable, fallback to localhost (avoids SameSite=Lax cross-site issues locally)
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000",
  timeout: 120000,
});

export default baseAxios;
